import { Element } from './Element'
import { Frame } from './Frame'
import { debounce } from '../debounce'
import { removeScrollWrapperMask } from './helpers'
import SmoothScroll from 'smooth-scroll'
const smoothScroll = new SmoothScroll()

const debouncedMaskRemover = debounce(removeScrollWrapperMask, 200)

class Animation {
	constructor (wrapper, scene, top) {
		this.wrapper = wrapper
		this.scene = scene
		this.top = top || 90

		this.elements = []
		this.frames = []
		this.plugins = {}
		this.progressListeners = []

		window.addEventListener('scroll', () => {
			this.scrollHandler()
			debouncedMaskRemover()
		})
	}

	scrollHandler () {
		if (window.innerWidth >= 1200) {
			if (this.isFixed) this.setFixedStyles()
			else if (this.isBottom) this.setBottomStyles()
			else this.setTopStyles()

			this.wrapper.classList.add('scroll-wrapper-mask')
		}
	}

	get length () {
		return this.frames.reduce((val, frame) => val + frame.length, 0)
	}

	get isBottom () {
		const bottomWrapper = this.wrapper.getBoundingClientRect().bottom
		return bottomWrapper < window.innerHeight
	}

	get isFixed () {
		const bottomWrapper = this.wrapper.getBoundingClientRect().bottom
		const topWrapper = this.wrapper.getBoundingClientRect().top

		return bottomWrapper >= window.innerHeight && topWrapper <= this.top
	}

	get progress () {
		const topWrapper = this.wrapper.getBoundingClientRect().top
		return -1 * (topWrapper - this.top) / (this.height - (window.innerHeight - this.top))
	}

	get distance () {
		return this.progress * this.length
	}

	get wrapperScrollTop () {
		return this.wrapper.getBoundingClientRect().top + window.scrollY
	}

	get height () {
		return this.wrapper.clientHeight
	}

	setTopStyles () {
		this.scene.classList.add('scene--top')
		const frame = this.frames[0]
		this.elements.map(element => element.onProgressChange(0, frame))
	}

	setBottomStyles () {
		this.scene.classList.add('scene--bottom')
		const frame = this.frames[this.frames.length - 1]
		this.elements.map(element => element.onProgressChange(1, frame))
	}

	setFixedStyles () {
		this.scene.classList.remove('scene--bottom')
		this.scene.classList.remove('scene--top')

		const frame = this.frames.find(frame => frame.checkDistance(this.distance))
		const frameProgress = (this.distance - frame.start) / frame.length

		this.elements.map(element => element.onProgressChange(frameProgress, frame))

		const progress = this.distance / this.length
		this.progressListeners.map(callback => callback(progress))
	}

	onTop (callback) {
		this.onTopCallback = callback
	}

	onBottom (callback) {
		this.onBottomCallback = callback
	}

	addElement (node, alias, config = {}) {
		const element = new Element()
		element
			.setAlias(alias)
			.setNode(node)
			.setConfig(config)

		this.elements.push(element)

		return this
	}

	addFrame (length, params, name = false) {
		const frame = new Frame()
		frame
			.setScene(this)
			.setLength(length)
			.setParams(params)
			.setStart(this.length)
			.setPrevFrame(this.frames[this.frames.length - 1])
			.setName(name)

		this.frames.push(frame)

		return this
	}

	addPlugin (name, callback) {
		this.plugins[name] = callback

		return this
	}

	addProgressChangedHandler (callback) {
		this.progressListeners.push(callback)

		return this
	}

	navigateTo (name) {
		const frame = this.frames.find(frame => frame.name === name)
		const end = frame.end
		const length = end / this.length * (this.height - window.innerHeight + this.top) - this.top + 1
		const scroll = length + this.wrapperScrollTop
		smoothScroll.animateScroll(scroll, null, {
			durationMax: 2000 * Math.abs(window.scrollY - scroll) / this.height
		})
	}

	init () {
		this.scrollHandler()
		this.scene.classList.remove('d-none')
	}
}

const px = 'px'
const percent = '%'
const _ = 'last_value'

export {Animation, px, percent, _}



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/modules/scrollAnimation/Animation.js